import { render, staticRenderFns } from "./docManage.vue?vue&type=template&id=38ca0b58&scoped=true"
import script from "./docManage.vue?vue&type=script&lang=js"
export * from "./docManage.vue?vue&type=script&lang=js"
import style0 from "./docManage.vue?vue&type=style&index=0&id=38ca0b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ca0b58",
  null
  
)

export default component.exports